<template>
    <div ref="table-content" :class="['table-content', densidadComoda ? 'table-content-comoda' : 'table-content-predeterminada']" :id="`datatable_${entidadRelacionada}`" v-loading="loading">

        <!-- Hay una configuracion que mostrar -->
        <template v-if="table.tableConfig && table.tableData && !error">
            
            <!-- Elementos por pagina y contador de registros total -->
            <el-row>
                <el-col>
                    <div class="table-footer">
                        <div class="table-footer-left">

                            <!-- Resultados por pagina -->
                            <el-select
                                v-if="visibleSearchRow"
                                :disabled="disabledSelectRow || loading"
                                @change="handleSizeChange"
                                class="table-register-page"
                                size="mini"
                                :value="pagination.rows"
                                placeholder="Select">

                                <el-option label="10/página" :value="10">10/página</el-option>
                                <el-option label="20/página" :value="20">20/página</el-option>
                                <el-option label="30/página" :value="30">30/página</el-option>
                                <el-option label="40/página" :value="40">40/página</el-option>
                            </el-select>

                            <!-- Boton ampliar columnas | Buscador | paginacion | buscador secundario -->
                            <i 
                                v-if="visibleSetFullScreen"
                                class="button-fullscreen"
                                style="margin-right: 0.3rem"
                                @click="fullScreen()"
                                :class="[setFullscreen ? 'el-icon-menu' : 'el-icon-s-grid']"></i>
                        
                            <el-select
                                class="select-buscador" 
                                style="margin-right: 0.3rem"
                                v-if="ficha && ficha.buscador && ficha.buscador.length  > 1 && entidadRelacionada"
                                :value="setEntidadRelacionada"
                                @change="changeSelectBuscador"
                                :disabled="loading"
                                placeholder="Select" 
                                size="mini">

                                <el-option
                                    v-for="item in ficha.buscador.filter(f => f.titulo && f.valor)" 
                                    :label="item.titulo" 
                                    :value="item.valor" 
                                    :key="item.valor"/>
                            </el-select>

                            <el-button
                                v-if="visibleReload"
                                style="margin-right: 0.3rem"
                                size="mini"
                                icon="el-icon-refresh"
                                :disabled="loading"
                                @click="clearFilters()">
                                Limpiar filtros
                            </el-button>

                            <el-button
                                v-if="['buscador','cuadromando'].includes(tipo)"
                                style="margin-right: 0.3rem;margin-left: 0"
                                size="mini"
                                icon="el-icon-printer"
                                :disabled="loading"
                                @click="getInformes()">
                            </el-button>
                            
                            <template v-if="+table.tableData.totalRows > 0">
                                <el-dropdown style="margin-right: 0.3rem" trigger="click" :hide-on-click="false">
                                    <el-button type="default" size="mini">
                                        <i class="el-icon-setting"></i> <i class="el-icon-arrow-down el-icon--right"></i>
                                    </el-button>
                                    <el-dropdown-menu slot="dropdown" class="dropdown-menu-table">

                                        <el-dropdown-item>
                                            <el-menu :collapse="false">

                                                <el-menu-item index="1">
                                                    <el-checkbox v-model="densidadComoda">Vista cómoda</el-checkbox>
                                                </el-menu-item>
                                                
                                                <el-menu-item index="2" :disabled="!(table.tableConfig.grouping && anyColOrdered >= 0)">
                                                    <el-checkbox v-model="grouped" @click="agrupar()">Agrupar</el-checkbox>
                                                </el-menu-item>
                                            </el-menu>
                                        </el-dropdown-item>

                                        <el-dropdown-item divided>

                                            <el-menu :collapse="false">

                                                <!-- Columnas -->
                                                <el-submenu index="3">
                                                    <template slot="title">
                                                        <i class="el-icon-s-grid"></i>
                                                        <span slot="title">Columnas</span>
                                                    </template>
                                                    <el-menu-item-group style="max-height: 250px; overflow: auto">
                                                        <el-menu-item 
                                                            key="all" 
                                                            style="
                                                                display: flex;
                                                                justify-content: space-between;
                                                                align-items: center;
                                                                color: rgb(148, 148, 148);
                                                            ">
                                                            Seleccionar todas 
                                                            <el-switch
                                                                v-model="selectAllColumns">
                                                            </el-switch>
                                                        </el-menu-item>
                                                        <el-menu-item 
                                                            v-for="(col, i) in table.tableConfig.cols"
                                                            :key="i"
                                                            :index="`cols-${i}`">

                                                            <el-checkbox 
                                                                v-model="col.visible" 
                                                                :disabled="grouped && anyColOrdered >= 0 && table.tableConfig.cols[anyColOrdered].prop == col.prop">
                                                                    {{col.label}}
                                                            </el-checkbox>
                                                        </el-menu-item>
                                                    </el-menu-item-group>
                                                </el-submenu>
                                                
                                                <!-- Mostrar -->
                                                <el-submenu index="4">
                                                    <template slot="title">
                                                        <i class="el-icon-circle-check"></i>
                                                        <span slot="title">Mostrar</span>
                                                    </template>
                                                    <el-menu-item-group>
                                                        <el-menu-item index="4-1">
                                                            <el-checkbox v-model="showFiltered">Filtros</el-checkbox>
                                                        </el-menu-item>
                                                        <el-menu-item index="4-3">
                                                            <el-checkbox v-model="showTableStripe">Modo stripe</el-checkbox>
                                                        </el-menu-item>
                                                        <el-menu-item index="4-2">
                                                            <el-checkbox v-model="showPagination">Paginación</el-checkbox>
                                                        </el-menu-item>
                                                        <el-menu-item index="4-3">
                                                            <el-checkbox v-model="showPaginationGoTo">Ir a</el-checkbox>
                                                        </el-menu-item>
                                                    </el-menu-item-group>
                                                </el-submenu>
                                            </el-menu>

                                        </el-dropdown-item>

                                        <el-dropdown-item divided>
                                            <el-menu :collapse="false">
                                                <el-menu-item index="5" @click="reloadContent()">
                                                    <i class="el-icon-refresh"></i>
                                                    <span>Recargar datos</span>
                                                </el-menu-item>

                                                <el-menu-item index="6" disabled>
                                                    <i class="el-icon-s-operation"></i>
                                                    <span>Personalización</span>
                                                </el-menu-item>
                                            </el-menu>
                                        </el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>

                                <!-- Paginacion (Solo visible si hay mas de una pagina) -->
                                <template v-if="Math.ceil(table.tableData.totalRows / pagination.rows) > 1">
                                    <el-pagination
                                        style="margin-right: 0.3rem"
                                        v-if="showPagination"
                                        :page-count="pageCount"
                                        :pager-count="5"
                                        :page-sizes="[10,20,50,100,200]"
                                        @size-change="handleSizeChange"
                                        @current-change="handleCurrentChange"
                                        :current-page="pagination.page"
                                        :page-size="pagination.rows"
                                        layout="sizes, prev, pager, next, jumper"
                                        :disabled="loading"
                                        :total="+table.tableData.totalRows">
                                    </el-pagination>
                                    <span v-if="showPaginationGoTo" class="total-jumper">de {{Math.ceil(table.tableData.totalRows / pagination.rows)}}</span>
                                </template>
                            </template>

                            <el-input
                                style="margin-right: 0.3rem"
                                v-if="visibleSearch"
                                placeholder="Buscar..." 
                                v-model="search" 
                                size="mini"
                                :disabled="loading"
                                @keyup.enter.native="getData()"
                                class="input-with-select">
                                
                                <el-button 
                                    slot="append" 
                                    icon="el-icon-search" 
                                    @click="getData()"/>
                            </el-input>

                            <!-- Acciones generales de la tabla -->
                            <el-button-group v-if="actions && actions.length" style="margin-left: 0.3rem">
                                
                                <el-button
                                    size="mini"
                                    v-for="(action,i) in actions" 
                                    :key="i"
                                    @click="porlet.events.clickAction(action, {intable: true, reftable: `datatable_${entidadRelacionada}_${id}`})">
                                        <i v-if="action.icon" :class="[action.icon]"></i> 
                                        {{action.titulo}}
                                </el-button>
                            </el-button-group>
                                    
                        </div>

                        <div class="table-footer-right">
                            <p class="table-total-counter">Total: {{table.tableData.totalRows}}</p>
                        </div>
                    </div>
                </el-col>
            </el-row>

            <template v-if="table.tableData.datos && table.tableData.datos.length || filtered">

                <!-- Tabla -->
                <el-row :style="{'--placeholder': table.tableConfig.attr && table.tableConfig.attr.hasOwnProperty('colorPlaceholder') ? table.tableConfig.attr.colorPlaceholder : '#010101'}">
                    <el-col :span="24">
                        <el-table
                        ref="table"
                        :data="groupedData"
                        :stripe="showTableStripe"
                        border
                        :span-method="arraySpanMethod"
                        :show-summary="true"
                        :summary-method="getSummaries"
                        @row-click="tableRowClick"
                        @row-dblclick="tableRowDblClick"
                        @selection-change="(val) => multipleSelection = val"
                        style="width: 100%">

                            <template v-for="(col, i) in table.tableConfig.cols">
                                
                                <el-table-column
                                v-if="col.type == 'selection'"
                                type="selection"
                                width="39">
                                </el-table-column>

                                <el-table-column
                                :key="i"
                                v-else-if="col.visible ? setFullscreen == true ? true : !col.fullscreen : false"
                                :prop="col.prop"
                                :label="col.label"
                                :align="col.align"
                                :width="col.width || 120"
                                :fit="false"
                                :class-name="col.hasOwnProperty('truncate') ? col.truncate : 'truncate'"
                                :sortable="false">
                                    
                                    <!-- :sortable="col.orden == 0 ? false : 'custom'" -->
                                    <template slot="header" slot-scope="scope">
                                        <div class="col-title">
                                            <p>{{col.label}}</p>
                                            <div 
                                                class="sortable"
                                                v-if="col.orden !== 0"
                                                @click="tableSortChange(col)">
                                                <i :class="['el-icon-caret-top', {active: col.orden == 2}]"></i>
                                                <i :class="['el-icon-caret-bottom', {active: col.orden == 3}]"></i>
                                            </div>
                                        </div>

                                        <div class="col-filter" v-if="showFiltered">
                                            <!--<el-input
                                                @keyup.enter.native="handleFilterColumn($event,col.prop)"
                                                type="text"
                                                v-model="col.buscador"
                                                :disabled="!col.filtrar"
                                                size="mini"
                                                suffix-icon="el-icon-s-operation">
                                            </el-input>-->

                                            <el-input
                                                :disabled="!col.filtrar"
                                                v-model="col.buscador"
                                                @keyup.enter.native="handleFilterColumn($event,col.prop)"
                                                type="text"
                                                size="mini"
                                                class="input-with-select-comparador">
                                                <el-select v-model="col.comparador" slot="append" v-if="col.comparador" @change="handleFilterColumn">
                                                    <el-option
                                                        style="min-width: 180px;"
                                                        v-for="(operator, i) in getOperatorByFormat(col)"
                                                        :key="i"
                                                        :label="operator.operator"
                                                        :value="operator.id">
                                                        <span style="float: left">{{ operator.label }}</span>
                                                        <span style="float: right; color: #8492a6; font-size: 13px">{{ operator.operator}}</span>
                                                    </el-option>
                                                </el-select>
                                            </el-input>
                                        </div>
                                    </template>

                                    <template slot-scope="scope">
                                        <div :class="[{gruped: anyColOrdered >= 0 && scope.row[table.tableConfig.cols[anyColOrdered].prop] === 'first'}]">
                                            <!-- Acciones -->
                                            <el-button-group v-if="col.type=='actions' && scope.row['actions']">
                                            
                                                <el-button
                                                    v-for="action in Object.keys(scope.row['actions'].actions)"
                                                    :key="action"
                                                    size="mini"
                                                    :title="scope.row['actions'].actions[action].titulo"
                                                    @click="clickActionRow({row: scope.row, action: scope.row['actions'].actions[action]})">
                                                        <i :class="scope.row['actions'].actions[action].icon"></i>
                                                        <!--{{scope.row['actions'].actions[action].titulo}}-->
                                                </el-button>
                                            </el-button-group>
                                            
                                            <!-- Input -->
                                            <inputSigarus
                                                v-else-if="col.label !== ''"
                                                :identificador="id"
                                                :entidad="entidad"
                                                ref="input"
                                                :input="col.input"
                                                :type="col.format"
                                                :value="col.format == 'datepicker' ? ['0000-00-00',null,'',undefined].includes(scope.row[col.prop]) ? '' : moment(scope.row[col.prop],'YYYY-MM-DD').format('DD/MM/yyyy') : scope.row[col.prop]"
                                                placeholder=""
                                                :readonly="true"
                                            />
                                        </div>
                                    </template>

                                </el-table-column>
                            
                            </template>

                            <!--<el-table-column
                                label="Acciones"
                                :width="120">
                                <template slot-scope="scope">
                                    <el-button
                                    size="mini"
                                    @click="handleEdit(scope.$index, scope.row)">Editar</el-button>
                                </template>
                            </el-table-column>-->

                            <!--<template v-if="table.tableConfig.actions">
                                <el-table-column
                                fixed="right"
                                label="Acciones"
                                width="120">
                                    <template slot-scope="scope">
                                        <el-button
                                        v-for="(action, a) in table.tableConfig.actions"
                                        :key="a"
                                        @click.native.prevent="clickAction(scope.$index, table.tableData.datos, action)"
                                        type="text"
                                        size="small">
                                        {{action.name}}
                                        </el-button>
                                    </template>
                                </el-table-column>
                            </template>-->

                        </el-table>
                    </el-col>
                </el-row>

            </template>
            <template v-else-if="!filtered">
                <el-row>
                    <el-col>
                        <div class="empty">
                            <img src="../../assets/NoSearchResult.png">
                            <p>No hay información que mostrar</p>
                        </div>
                    </el-col>
                </el-row>
            </template>
            
        </template>

        <!-- Errores -->
        <template v-else-if="error">
            <el-row style="padding: 10px; min-height: 150px">
                <el-col :span="24">
                    <div class="empty">
                        <img src="../../assets/Error.png">
                        <p>Ha ocurrido un error, vuelve a recargar mas tarde</p>
                    </div>
                </el-col>
            </el-row>
        </template>

        <!-- Requiere una recarga para obener datos -->
        <template v-else>
            <div v-if="loading" class="loading" v-loading="true"></div>
            <div class="empty">
                <img src="../../assets/NoSearchResult.png">
                <p>Recarga para obtener datos</p>
            </div>
        </template>
        
    </div>
</template>

<script>

    import {
		postSelectorEntidad,
        getSelectorEstructura,
        getSelectorDatos,

        getRelacionEstructura,
        getRelacionDatos,

        getBuscadorEstructura,
        getBuscadorCuadroMandosEstructura,
        getBuscadorDatos,
        getBuscadorDatosCuadroMandos,

        setDefaultsHeaders,

        getTableInforme,
        getTableInformeCuadromando,
        getUrl,

        getListaDocumentosPdf
    } from '@/helpers/api'
    
    import InputSigarus from '@/components/inputs/InputSigarus.vue'

    import moment from 'moment'

    import { mapState, mapMutations } from 'vuex'

	export default {
        name: 'TableElement',
        props: {
            tipo: {
                type: String,
                required: false,
                default: () => 'selector'
            },
            id: [Number,String],
            ficha: Object,
            entidad: String,
            entidadRelacionada: String,
            porlet: Object,
            currentAction: Object,
            pageCount: {
                type: Number,
                default: () => 8
            },
            disabledSelectRow: {
                type: Boolean,
                required: false,
                default: () => true
            },
            visibleSetFullScreen: {
                type: Boolean,
                required: false,
                default: () => false
            },
            visibleSearchRow: {
                type: Boolean,
                required: false,
                default: () => false
            },
            visibleSearch: {
                type: Boolean,
                required: false,
                default: () => false
            },
            reload: {
                type: Boolean,
                required: false,
                default: () => false
            },
            autoReload: {
                type: Boolean,
                required: false,
                default: () => false
            },
            fullscreen: {
                type: Boolean,
                required: false,
                default: () => true
            },
            visibleReload: {
                type: Boolean,
                required: false,
                default: () => false
            },
            fromModal: {
                type: Boolean,
                required: false,
                default: () => false
            },
            rowClickEnabled: {
                type: Boolean,
                required: false,
                default: true
            },
            rowDblClickEnabled: {
                type: Boolean,
                required: false,
                default: true
            },
            activetab: {
                type: String
            },
            autoReload: {
                type: Boolean,
                default: true
            },
            belongsTab: {
                type: String
            }
        },
        components: {
            InputSigarus
        },
		data () {
			return {
                moment,
                search: '',
                table: {},
                loading: false,
                pagination: {
                    page: null,
                    rows: null
                },
                error: null,
                setFullscreen: false,
                setEntidadRelacionada: false,
                filtered: false,

                multipleSelection: [],
                densidadComoda: false,

                // Agrupado
                grouped: false,

                // Opciones mostrar
                showFiltered: true,
                showPagination: true,
                showPaginationGoTo: true,
                showTableStripe: false,

                // Comparador
                filters_operator: [{
                        id: 1,
                        label: 'Igual',
                        operator: '='
                    }, {
                        id: 2,
                        label: 'Mayor/igual',
                        operator: '>='
                    }, {
                        id: 3,
                        label: 'Menor/igual',
                        operator: '<='
                    }, {
                        id: 4,
                        label: 'Mayor',
                        operator: '>'
                    }, {
                        id: 5,
                        label: 'Menor',
                        operator: '<'
                    }, {
                        id: 6,
                        label: 'Contiene',
                        operator: '@'
                    }, {
                        id: 7,
                        label: 'Empieza',
                        operator: '['
                    }, {
                        id: 8,
                        label: 'Termina',
                        operator: ']'
                    }, {
                        id: 9,
                        label: 'Entre',
                        operator: '<>'
                    }, {
                        id: 10,
                        label: 'Diferente',
                        operator: '!='
                    }, {
                        id: 11,
                        label: 'No contiene',
                        operator: '!@'
                    } /*,{
                        id: 12,
                        label: 'Lista',
                        operator: '≡'
                    }*/, {
                        id: 13,
                        label: 'Vacio',
                        operator: '□'
                    }, {
                        id: 14,
                        label: 'No vacio',
                        operator: '▦'
                    }, {
                        id: 15,
                        label: 'Listado',
                        operator: '≡'
                    }
                ],
                filters_comparador_text: [1,6,7,8,10,11,13,14,15],
                filters_comparador_number: [1,2,3,4,5,9,10,13,14,15],
                filters_comparador_datepicker: [1,2,3,4,5,9,10,13,14,15],
                filters_comparador_datetimepicker: [1,2,3,4,5,9,10,13,14,15],
                
                // Selector de todas las columnas
                selectAllColumns: true
            }
        },
        mounted() {

            if (this.autoReload) {

                this.init()

                this.getConfig()
            }

            this.$emit('created')
        },
        watch: {
            pagination: {
                handler(newval,oldval) {
                    if(
                        oldval.page != null && 
                        oldval.rows != null && 
                        this.pagination.page && 
                        this.pagination.rows
                    ) {
                        if (this.loading) return
                        this.getData()
                    }
                },
                deep: true
            },
            reload () {
                if (this.reload) {
                    this.reloadContent()
                }
            },
            grouped () {
                
                this.agrupar()
            },
            activetab(val) {
                
                if(val == this.belongsTab && this.autoReload == false && !this.table.tableConfig) {

                    this.init()

                    this.getConfig()
                }
            },
            selectAllColumns(val) {

                this.loading = true

                this.table.tableConfig.cols.forEach(col => col.visible = val)

                this.$nextTick(() => {
                    this.loading = false
                })
            }
        },
        computed: {
            ...mapState({
				user: state => state.user.data
			}),
            actions () {
                return Object.keys(this.table.tableConfig.actions).map(accion => {
                    let m = this.table.tableConfig.actions[accion]
                    return {
                        ...m,
                        auto: m.auto || true,
                        function: m.function || null,
                        url: m.url ? m.url.replace('@@id@@',this.id) : null
                    }
                })
            },
            anyColOrdered() {
                // Devuelve el indice de la primera columna por la que se esta ordenando
                return this.table.tableConfig.cols.findIndex(f => ![0,1].includes(f.orden))
            },
            groupedData() {
                let items = this.table.tableData.datos

                if(this.grouped && this.anyColOrdered >= 0) {

                    let agrupado = this.groupBy(items, this.table.tableConfig.cols[this.anyColOrdered].prop)

                    items = []

                    Object.keys(agrupado).forEach(key => {
                        agrupado[key].forEach((row) => {
                            if(!items.find(f => f[this.table.tableConfig.cols[this.anyColOrdered].prop] == key)) {
                                
                                let first = {
                                    ...row
                                }
                                first[this.table.tableConfig.cols[this.anyColOrdered].prop] = 'first'
                                first[this.table.tableConfig.cols[this.anyColOrdered === 0 ? 1 : 0].prop] = key
                                items.push(first)
                            }
                            items.push(row)
                        })
                    })
                }
                
                return items
            },
            anchuraDisponible() {
                return this.$refs['table-content'].clientWidth - 2
            }
        },
        methods: {
            init() {
                this.setFullscreen = this.fullscreen
                this.setEntidadRelacionada = this.entidadRelacionada
            },
            async getConfig() {

                console.log('DATATABLE GET CONFIG')

                if (this.loading) return
                
                this.error = false
                this.table = {}

                this.loading = true

                try {

                    let resp = null
                    if (this.tipo == 'relacion') {

                        console.log('entidad: ' + this.entidad + '/ Entidad Relacionada: ' + this.setEntidadRelacionada)

                        resp = await getRelacionEstructura(this.entidad, this.setEntidadRelacionada, this.user)

                    } else if (this.tipo == 'cuadromando') {

                        resp = await getBuscadorCuadroMandosEstructura(this.setEntidadRelacionada,this.user)

                    } else if (this.tipo == 'buscador') {

                        resp = await getBuscadorEstructura(this.entidad, this.setEntidadRelacionada, this.user)
                        
                    } else {
                        resp = await getSelectorEstructura(this.setEntidadRelacionada, this.user)
                    }
                    
                    if (resp.status == 200 && typeof resp.data == 'object') {
                        
                        let cols = resp.data.cols.map(m => {
                            return {
                                visible: true,
                                ...m
                            }
                        })

                        //let sumaCols = resp.data.cols.reduce((acum, obj) => acum + parseInt(obj.width), 0)
                        //let espacioLibre = this.anchuraDisponibl - sumaCols

                        if(!(resp.data.cols.length == 1 && resp.data.cols[0].dividerScreen) && resp.data.cols.every(e =>e.width !== 'auto')) {
                            cols.push({
                                align: "left",
                                buscador: null,
                                filtrar: false,
                                format: "text",
                                fullscreen: false,
                                label: "",
                                orden: 0,
                                prop: "",
                                width: 'auto',
                                visible: true
                            })
                        }

                        this.$set(this.table, 'tableConfig', {
                            ...resp.data,
                            cols
                        })

                        this.pagination = {
                            page: parseInt(resp.data.page),
                            rows: parseInt(resp.data.rows)
                        }
                        this.search = resp.data.buscadorGeneral || ''
                        
                        this.table.tableConfig.actions = resp.data.actions || {}
                        this.table.tableConfig.grouping = true // Permite agrupacion

                        await this.getData()

                    } else {
                        
                        this.error = true
                    }

                } catch(err) {
                    console.log(err)
                    this.error = true
                }

                this.loading = false

            },
            async getData(filters = []) {

                this.loading = true

                try {
                    
                    if(this.table.tableConfig) {
                        
                        let resp = null
                        let data = {
                            config: JSON.stringify({
                                ...this.pagination, 
                                buscadorGeneral: this.search, 
                                cols: this.table.tableConfig.cols,
                                filtros: this.table.tableConfig.filtros || null
                            }),
                            filters
                        }
                        if (this.id) data.padreId = this.id

                        
                        if (this.tipo == 'relacion') {
                            resp = await getRelacionDatos(this.entidad, this.setEntidadRelacionada, data)

                        } else if (this.tipo == 'buscador') {
                            
                            resp = await getBuscadorDatos(this.entidad, this.setEntidadRelacionada, data)
                            
                        } else if (this.tipo == 'cuadromando') {

                            resp = await getBuscadorDatosCuadroMandos(this.setEntidadRelacionada,data)

                        } else {
                            resp = await getSelectorDatos(this.setEntidadRelacionada,data)
                        }

                        if (resp.status == 200 && typeof resp.data == 'object') {

                            this.$set(this.table, 'tableData', resp.data)

                            this.checkIsFiltered()
                            
                        } else if (resp.status == 203 && resp.data.view) {
                            
                            this.$set(this.table, 'tableData', resp.data)

                            this.checkIsFiltered()

                            this.porlet.events.updateFicha(resp.data, resp.data.status)

                        } else {
                            //console.log('error datos')
                            this.error = true
                        }
                        
                    } else {
                        //console.log('getData -> no hay config')
                        this.error = true
                    }

                } catch(err) {
                    //console.log('error cacth datos')
                    console.log(err)
                    this.error = true
                }

                this.loading = false
                
            },
            
            // Obtener operador por formato de input
            getOperatorByFormat(col) {
                const filtro_comparador = col.filtro_comparador ||  this[`filters_comparador_${col.format.includes('number') ? 'number' : ['link', 'timepicker'].includes(col.format) ? 'text' : col.format}`]
                return this.filters_operator.filter(f => filtro_comparador.includes(f.id))
            },

            // Agrupar
            agrupar() {
                //this.grouped = !this.grouped
                this.table.tableConfig.cols[this.anyColOrdered].visible = !this.table.tableConfig.cols[this.anyColOrdered].visible
            },

            arraySpanMethod({ row, column, rowIndex, columnIndex }) {
                if (this.anyColOrdered >= 0 && row[this.table.tableConfig.cols[this.anyColOrdered].prop] == 'first') {
                    if(columnIndex === 0) {
                        return [1,this.table.tableConfig.cols.filter(f => f.visible).length]
                    } else {
                        return [0,0]
                    }
                }
            },

            fullScreen() {

                this.setFullscreen = !this.setFullscreen

                /*this.table.tableConfig.cols.forEach(col => {
                    col.visible = setFullscreen
                })*/
                
                
            },

            checkIsFiltered() {
                let filter = false
                if (
                    this.table && 
                    this.table.tableConfig && 
                    (
                        this.table.tableConfig.cols.some(col => col.buscador && col.buscador !== "") ||
                        this.table.tableData.buscadorGeneral && this.table.tableData.buscadorGeneral !== ""
                    )
                ) {
                    filter = true
                }
                this.filtered = filter
            },

            // Pie totales
            getSummaries(param) {
                
                const { columns, data } = param;
                const sums = [];
                columns.forEach((column, index) => {
                
                    if (column.summary) {
                        sums[index] = column.summary;
                    } else {
                        sums[index] = '';
                    }
                });

                return sums;
            },

            // Actualizar contenido
            refresh() {
                this.init()

                if (this.autoReload) {
                    this.getConfig()
                }
            },
            refreshData() {
                this.reloadContent()
            },

            // Boton informes
            async getInformes() {

                this.loading = true

                try {
                    
                    let data = {
                        config: JSON.stringify({
                            ...this.pagination, 
                            buscadorGeneral: this.search, 
                            cols: this.table.tableConfig.cols,
                            filtros: this.table.tableConfig.filtros || null
                        })
                    }
                    
                    let resp = null
                    if (this.tipo == 'cuadromando') {
                        resp = await getTableInformeCuadromando({data, entidad: this.entidad})
                    } else {
                        resp = await getTableInforme({data, entidad: this.entidad})
                    }

                    if (resp && resp.data && resp.data.link) {
                        this.openwindow(`${getUrl().backend}download?link=${resp.data.link}`)
                    }

                } catch(err) {
                    //this.error = true
                    this.$notify.error({
                        title: 'Error',
                        message: 'Inténtalo de nuevo mas tarde'
                    });
                }

                this.loading = false
            },

            // Acciones
            tableSortChange(col) {

                /*let ord= {
                    'ascending': 2,
                    'descending': 3
                }*/

                let nextOrder = (col.orden == 1) ? 2 : (col.orden == 2) ? 3 : 1

                let colExist = this.table.tableConfig.cols.find(f => f.prop == col.prop)
                if (colExist) {
                    //colExist.orden = col.order ? ord[col.order] : 1
                    colExist.orden = nextOrder
                }

                this.getData()

            },
            async tableRowDblClick(value) {
                
                if (!this.rowDblClickEnabled || this.tipo == 'cuadromando') return

                if (this.tipo == 'buscador') {
                    this.$emit('dblclick',{...value, dividerScreen: this.table.tableConfig.cols[0].dividerScreen}, true)
                } else if (this.tipo == 'relacion') {
                    this.$emit('openWindow',{...value, entidad: this.entidadRelacionada.replace('_noEditable','')})
                }
            },
            async tableRowClick(row, column, event) {
                
                if (!this.rowClickEnabled || this.tipo == 'cuadromando') return

                if (event.target.tagName.toLowerCase() === 'a') return // Si el click es sobre un enlace, o abrimos ventana
                
                this.loading = true

                try {

                    if (this.tipo == 'selector' && !this.fromModal) {

                        let resp = await postSelectorEntidad(this.entidadRelacionada, {
                            field: this.currentAction.input.key,
                            newvalue: row.id
                        })

                        /*if(resp && resp.data && resp.data.mensajes) {
                            resp.data.mensajes.forEach(mensaje => {
                                this.$notify({
                                    title: mensaje.title,
                                    message: mensaje.message,
                                    type: mensaje.type,
                                    position: mensaje.position
                                })
                            })
                        }*/
                        
                        this.$emit('closeTableClick', {data: resp.data.data, status: resp.status})

                        this.$emit('saved', resp.data)

                    }
                    /* else if(this.tipo == 'relacion' && this.table.tableConfig.enlazar) {
                        this.openwindow(`/ficha/${this.entidadRelacionada}/${row.id}`,'_blank')
                        this.$emit('closeTableClick')
                    }*/
                    
                    this.$emit('close',{...row, dividerScreen: this.table.tableConfig.cols[0].dividerScreen}, false)
                    
                } catch(err) {
                    
                    // Notificciones
                    if (err && err.response && err.response.data && err.response.data.mensajes) {
                        err.response.data.mensajes.forEach(mensaje => {
                            setTimeout(() => {
                                this.$notify({
                                    title: mensaje.title,
                                    message: mensaje.message,
                                    type: mensaje.type,
                                    position: mensaje.position
                                });
                            }, 5)
                        })
                    } else {
                        this.$notify({
                            title: 'Error',
                            message: 'Algo ha salido mal',
                            type: 'error'
                        })
                    }
                }

                this.loading = false
            },
            handleFilterColumn(e,prop) {
                
                let colExist = this.table.tableConfig.cols.find(f => f.prop == prop)
                console.log(colExist)
                // Comprobar campo fecha y validar valor solo cuando el comparador es "entre"
                if (colExist && colExist.format === 'datepicker' && colExist.comparador == 9) {
                    let regex = /^[0-9]+;[0-9]+$/i;
                    if(!regex.test(colExist.buscador)) {
                        this.$notify.error({
                            title: 'Error formato fecha',
                            message: 'Debe especificar ddmmyy;ddmmyy'
                        })
                        return
                    }
                }

                // Comprobar campo numerico y validar valor solo cuando el comparador es "entre"
                if (colExist && colExist.format.includes('number') && colExist.comparador == 9) {
                    let numeros = colExist.buscador.split(';')
                    if (numeros.length == 2) {
                        if(
                            isNaN(parseFloat(numeros[0])) || 
                            isNaN(parseFloat(numeros[1])) 
                        ) {
                            this.$notify.error({
                                title: 'Error formato numérico',
                                message: 'Debe especificar XXXX;XXXX'
                            })
                            return
                        }
                    }
                }

                if (e.key == 'Enter') {
                    if (colExist) {
                        colExist.buscador = e.target.value
                        this.getData()
                    }
                } else {
                    // En filtro vacio/no vacio realizar busqueda automatica
                    if ([14,13].includes(e)) {
                        this.getData()
                    }
                }
            },
            async reloadContent (filters = []) {

                this.setAxiosHeaders()
                
                this.error = false
                
                if (!this.table.tableConfig) {
                    await this.getConfig()
                } else {
                    await this.getData(filters)
                }
                this.$emit('reloadEnd')
            },
            clearFilters() {
                this.table = {}
                this.pagination = {
                    page: null,
                    rows: null
                },
                
                this.reloadContent()
            },
            setAxiosHeaders() {
				/*axios.defaults.headers.common['Entidad'] = this.entidad
			
				if (this.id && !isNaN(parseInt(this.id))) {
					axios.defaults.headers.common['Id'] = this.id
				}*/

                setDefaultsHeaders(this.entidad, this.id)
			},

            // PAGINACION
            handleSizeChange(value) {
                this.pagination = {
                    rows: value,
                    page: 0
                }
            },
            handleCurrentChange(value) {
                this.pagination.page = value
            },
            handleSizeChange(value) {
                this.pagination.rows = value
            },

            // METODOS TABLE ACTIONS
            clickAction(index, tableData, action) {
                this[action.event](index, tableData)
            },
            // Accion desde boton de una celda
            clickActionRow({row,action}) {

                console.log('clickActionRow: ',row)

                action.url = `/${action.url.replace('@@id@@', row.id)}`
                action.auto = true

                this.porlet.events.clickAction(action)
            },
            editarLineaPedidoVenta(index, tableData) {
                this.$referencias.find(f => f.$options.name === 'custom_pedidoventa').seleccionarid(tableData[index].id)
            },

            // SELECT BUSCADOR
            changeSelectBuscador(value) {

                this.pagination = {
                    page: null,
                    rows: null
                }

                this.setEntidadRelacionada = value
                this.getConfig()
            },

            // UTILS
            groupBy(list, key) {
                let map = list.reduce((result, item) => {
                        return {
                            ...result,
                            [item[key]]: [
                                ...(result[item[key]] || []),
                                item,
                            ]
                        }
                        
                }, {})
                return map
            }
        }   
	}
</script>

<style lang="scss">
@import '@/assets/scss/variables.scss';
.table-content {
    position: relative;
    min-height: 150px!important;
    background-color: white;

    // Densidad
    &.table-content-predeterminada .el-table__body-wrapper tbody td > .cell {
        padding: 0rem 0rem;
    }
    &.table-content-comoda .el-table__body-wrapper tbody td > .cell {
        padding: 0.5rem 0rem;
        form .label {
            font-size: 0.8rem;
        }
    }
    &.table-content-compacta .el-table__body-wrapper tbody {
        td,
        td .cell {
            padding: 0!important;
        }
    }
    .el-table-column--selection .cell {
        padding-right: 14px!important;
        padding-left: 10px!important;
    }
    .loading {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        width: 100%;
        height: 100%;
        display: flex;
        z-index: 999;
        /*.el-loading-mask {
            background-color: rgba(255, 255, 255, 0.64);
        }*/
    }
    
    .table-content-header {
        display: flex;
        justify-content: space-between;
        padding: 10px 0px;

        .table-content-header--left {
            display: flex;
            align-items: center;

            > i {
                font-size: 1rem;
                margin-right: 10px;
                cursor: pointer;
            }
            .button-fullscreen {
                flex-shrink: 0;
            }
            .select-buscador {
                margin-right: 5px;
                flex-shrink: 0;
            }
            .el-pagination {
                flex-shrink: 0;
            }
            .total-jumper {
                font-size: 13px;
                height: 28px;
                line-height: 28px;
                vertical-align: top;
            }
        }
        
        .input-with-select {
            max-width: 200px;
            .el-input-group__prepend {
                background-color: #fff;
            }
        }
    }

    > .el-select > .el-input {
        min-width: 110px;
    }

    .el-table {
        border: 1px solid #dedede;
        overflow: hidden;

        tbody {
            td {
                padding: 2px 0;

                .cell {
                    font-size: 0.7rem;
                    form .label {
                        height: auto;
                        line-height: unset;
                        font-size: 0.7rem;
                    }
                    > .gruped {
                        background-color: #eaeaea;
                        font-weight: bold!important;
                    }
                }
                &.truncate {
                    .cell {
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }
                }
            }
        }
        thead {
            th {
                padding: 0px;
                text-align: center;
                .cell {
                    display: flex;
                    flex-flow: column;
                    position: relative;
                    padding: 0px;

                    .header-content {
                        flex-grow: 1;
                    }
                    .col-title {
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        background-color: $--color-header!important;
                        height: 39px;
                        p {
                            margin: 8px 0.5rem;
                            color: white;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                            overflow: hidden;
                        }

                        .sortable {
                            display: flex;
                            flex-flow: column;
                            position: relative;
                            height: 35px;
                            width: 20px;
                            right: 3px;
                            cursor: pointer;
                            i {
                                position: absolute;
                                color: white;
                                &.el-icon-caret-top {
                                    top: 8px;
                                    left: 2px;
                                    font-size: 0.8rem;
                                }
                                &.el-icon-caret-bottom {
                                    bottom: 8px;
                                    left: 2px;
                                    font-size: 0.8rem;
                                }
                                &.active {
                                    color: #409eff;
                                }
                            }
                        }
                        
                    }
                    .col-filter {
                        display: flex;
                        align-items: center;
                        flex-flow: row-reverse;
                        background-color: $--color-col-filter;
                        > div {
                            background-color: transparent;
                        }
                    }
                    > .el-input {
                        order: 2;
                        input {
                            border-radius: 0px;
                            border: 0px;
                            border-top: 1px solid #ecf5ff;
                            
                            &[disabled]::placeholder {
                                color: #409eff91!important;
                            }
                        }
                    }
                    .is-disabled .el-input__inner {
                        background-color: unset!important;
                    }
                    
                    /*.caret-wrapper {
                        order: 1;
                        height: 27px;
                        position: absolute;
                        right: 5px;
                        top: 5px;
                        .sort-caret.descending {
                            bottom: 2px;
                        }
                        .sort-caret.ascending {
                            top: 2px;
                        }
                    }*/
                    
                }
            }
        }
    }

    .table-register-page {
        padding: 10px 0px;
    }
    .table-total-counter {
        margin: 0px;
        text-align: right;
        padding: 10px 0.5rem;
        font-size: 0.8rem;
        color: #868686;
    }

    .el-pagination {
        display: flex;
        justify-content: center;
        li {
            &.number:not(.active) {
                display: none;
            }
            &.more {
                display: none;
            }
        }
    }

    .el-table__empty-block {
        min-height: 375px!important;
    }
    // Deja sin altura el input que no contenga value
    .truncate.placeholder {
        height: auto!important;
    }

    .table-footer {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-top: 5px;
        .table-footer-left {
            display: flex;
            align-items: center;
            flex-grow: 1;
            margin-left: 0.5rem;
        }
    }
}

.el-table--border::after,
.el-table--group::after,
.el-table::before {
    width: 0px!important;
}

// Desplegable de opciones de tabla
.dropdown-menu-table {
    > li {
        > ul {
            border-right: 0px;
        }
    }
    .el-dropdown-menu__item:focus, 
    .el-dropdown-menu__item:not(.is-disabled):hover {
        background-color: transparent;
        color: transparent;
    }
}

// DISEÑO DESPLEGABLE COMPARADOR
.input-with-select-comparador {
    background-color: #8bb9eb47;
    > input {
        border: 0px;
        background-color: transparent;
        border-radius: 0px;
    }
    .el-input-group__append {
        border-radius: 0px;
        background-color: transparent;
        border: 0px;
        border-left: 1px solid #8bb9eb45;
        padding: 0px 15px;
        border-right: 1px solid #8bb9eb45;
        .el-select {
            width: 30px;
            .el-input--suffix {
                .el-input__inner {
                    border: 0px;
                    border-radius: 0px;
                    text-align: center;
                    padding: 0px!important;
                }
                .el-input__suffix {
                    display: none !important;
                }
            } 
        }
    }
}
</style>